import Dexie from 'dexie'

export let db

export const initDb = ( key ) => {
	db = new Dexie( key )
	return db
}

export const getDb = () => {
	return db
}

export default {
	init: initDb,
	get: getDb,
	db: db
}
